import { useEffect, useMemo, useState } from "react";

export function useFilteredSalesData(
  objects,
  selectedOption,
  startDate,
  endDate
) {
  const [filteredData, setFilteredData] = useState([]);

  const parsedObjects = useMemo(() => {
    return objects.map((obj) => {
      const parts = obj.store_code.split("ANGELSPIZZA_");
      const codePart = parts.length > 1 ? parts[1] : "";
      return {
        ...obj,
        storeCodePart: codePart,
      };
    });
  }, [objects]);

  useEffect(() => {
    const filtered = parsedObjects.filter((obj) => {
      const matchesOption = selectedOption
        ? obj.storeCodePart === selectedOption
        : true;
      const createdAt = new Date(obj.tran_date);
      const start = startDate ? new Date(startDate) : new Date(0);
      const end = endDate ? new Date(endDate) : new Date();
      end.setHours(23, 59, 59, 999);
      return matchesOption && createdAt >= start && createdAt <= end;
    });
    setFilteredData(filtered);
  }, [parsedObjects, selectedOption, startDate, endDate]);

  return { parsedObjects, filteredData };
}
